/** 重置message，防止重复点击重复弹出message弹框 */
import { Message } from "ccui";
let messageInstance = null;
const resetMessage = options => {
  if (messageInstance) {
    messageInstance.close();
  }
  options.offset = 240;

  messageInstance = Message(options);
};
["error", "success", "info", "warning"].forEach(type => {
  resetMessage[type] = options => {
    if (typeof options === "string") {
      options = {
        message: options,
        showClose: true,
        duration: 1000 * 8,
        offset: 240
      };
    }
    options.type = type;
    return resetMessage(options);
  };
});
export const message = resetMessage;
